import Vue from 'vue';

class LogOutMaintenance {
  eventSource = null;
  reconnectAttempts = 0;
  maxReconnectAttempts = 5;
  reconnectDelay = 5000;

  connectToMaintenanceStream(store) {
    const token = localStorage.getItem('token');
    if (!token || token === 'null' || token === 'undefined') {
      return;
    }

    //const streamUrl = `${process.env.VUE_APP_BASE_SERVER}/sap-maintenance/stream?token=${token}`;

    try {
      //this.eventSource = new EventSource(streamUrl);

      this.eventSource.addEventListener('open', () => {
        this.reconnectAttempts = 0;
      });

      this.eventSource.addEventListener('ping', () => {});

      this.eventSource.addEventListener('maintenance-changed', (event) => {
        const data = JSON.parse(event.data || '{}');

        if (data.message === 'maintenanceOption_changed') {
          this.handleMaintenanceChange(store);
        }
      });

      this.eventSource.addEventListener('error', () => {
        this.handleStreamError(store);
      });

      this.eventSource.onerror = () => {
        this.handleStreamError(store);
      };
    } catch (error) {
      this.handleStreamError(store);
    }
  }

  handleMaintenanceChange(store) {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }

    if (store && store.dispatch && typeof store.dispatch === 'function') {
      store
        .dispatch('auth/signOut')
        .then(() => this.showAlertAndRedirect())
        .catch(() => {});
    } else {
      this.showAlertAndRedirect();
    }
  }

  handleStreamError(store) {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }

    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      const delay =
        this.reconnectDelay * Math.pow(2, this.reconnectAttempts - 1);

      setTimeout(() => {
        this.connectToMaintenanceStream(store);
      }, delay);
    }
  }

  showAlertAndRedirect() {
    Vue.swal
      .fire({
        title: 'Sesión finalizada',
        text: 'El sistema entró en modo de mantenimiento. Por favor, inicie sesión nuevamente.',
        icon: 'warning',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#ea2d22',
        customClass: {
          confirmButton: 'my-maintenance-button',
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })
      .then(() => {
        this.redirectToLogin();
      });
  }

  redirectToLogin() {
    try {
      if (Vue.router && typeof Vue.router.push === 'function') {
        Vue.router.push('/');
      }
      location.reload();
    } catch (error) {
      location.reload();
    }
  }

  disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
    this.reconnectAttempts = 0;
  }

  isConnected() {
    return this.eventSource && this.eventSource.readyState === EventSource.OPEN;
  }
}

export default new LogOutMaintenance();
